import { SelectButton } from "./SelectButton";
import { ZONES_STANDARD, ZONES_RH } from "./constants";

export const ZoneGrid = ({ selected, onChange, disabled, zoneType }) => (
  <div className="grid grid-cols-4 sm:grid-cols-7 gap-1 sm:gap-1.5">
    {zoneType === "rh-7-zone"
      ? ZONES_RH.map((zone) => (
          <SelectButton
            key={zone}
            selected={selected === zone}
            onClick={() => onChange(zone)}
            disabled={disabled}
          >
            {zone}
          </SelectButton>
        ))
      : ZONES_STANDARD.map((zone) => (
          <SelectButton
            key={zone}
            selected={selected === zone}
            onClick={() => onChange(zone)}
            disabled={disabled}
          >
            {zone}
          </SelectButton>
        ))}
  </div>
);
